module.exports = __webpack_public_path__ + "static/media/Jakarta Good Guide.b792dfc4.png";